import { type FC, useState } from 'react';
import { difference } from 'lodash-es';

import { type MCQuestion, type MCQuestionPool } from '@editor2/types/pageElements';
import ChildrenChangesWrapper from '../common/ChildrenChangesWrapper';
import ExpandChangesButton from '../common/ExpandChangesButton';
import ChangesDiff from '../common/ChangesDiff';
import DeletedItem from '../common/DeletedItem';
import { getPoolQuestionTitle } from '../helpers';
import { elementHeader } from '../styles';
import ChoicesDiff from './ChoicesDiff';

interface Props {
	initialElement: MCQuestionPool;
	currentElement: MCQuestionPool;
	questions: MCQuestion[];
}

const PoolQuestionsDiff: FC<Props> = (props) => {
	const { initialElement, currentElement, questions } = props;

	const [showChildren, setShowChildren] = useState(true);

	return (
		<>
			{questions && !showChildren && <ExpandChangesButton onClick={() => setShowChildren(true)} />}

			{showChildren && (
				<ChildrenChangesWrapper setShowChildren={setShowChildren}>
					{questions &&
						questions.map((question, i) => {
							const { id, choices, ...changes } = question;

							const initialIndex = initialElement?.questions.findIndex(
								(el) => el.family_id === currentElement.questions[i].family_id
							);
							const initialQuestion = initialElement?.questions[initialIndex];

							return (
								<div key={currentElement.questions[i].family_id}>
									<ChangesDiff
										index={i}
										initialIndex={initialIndex}
										initial={initialQuestion}
										attributeChanges={changes}
										title={`Question ${i + 1}`}
										styles={elementHeader}
									/>
									<ChoicesDiff
										initialElement={initialElement?.questions[i] as MCQuestion}
										currentElement={currentElement.questions[i]}
										choices={choices}
									/>
								</div>
							);
						})}

					{questions &&
						difference(
							initialElement?.questions.map((el) => el.family_id) || [],
							currentElement.questions.map((el) => el.family_id)
						).map((family_id) => {
							return (
								<DeletedItem
									key={family_id}
									title={getPoolQuestionTitle(
										initialElement?.questions.find((el) => el.family_id === family_id)
									)}
									styles={elementHeader}
								/>
							);
						})}
				</ChildrenChangesWrapper>
			)}
		</>
	);
};

export default PoolQuestionsDiff;
